// extracted by css-extract-rspack-plugin
export default {"mergeabilityIcon":"MergeabilityIcon-module__mergeabilityIcon__pgZrk"};